import { BASE_URL } from '@/router/consts'

const p = (postfix: string) => `${BASE_URL}${postfix}`

export const LIST_URL = p('')
export const LIST_FAVOURITE_URL = p('event/favourite')
